import { createAnchor, getPositionFromIndex } from "../components/AutoSuggestion";
import { findTabularEnvs, parseColumnSpec, findCommandorNot, capitalizeInsideBraces, isCommented, getallData, getInsideTextofBraces, createGranularAnchors, isLineCommented, LineCommented } from "../components/ReusableFunctions";
import { getOverlappingAnchors, isAlreadyAnchored, isRejectedByLivePosition } from "../components/AutoSuggestion";
export const epl = {
    RemoveHiddenText: {
        name: "Remove Hidden Text start with %",
        description: "Remove commented/hidden text from LaTeX",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const lines = texFile.split('\n');
            let index = 0;

            lines.forEach((line, lineNum) => {
                const lineStart = index;
                index += line.length + 1; // +1 for \n

                // Find % that is not escaped with \
                const commentIdx = line.search(/(?<!\\)%/);
                if (commentIdx === -1) return;

                const beforeComment = line.slice(0, commentIdx);
                const isFullLine = beforeComment.trim() === '';

                let fullMatch, matchIndex, extraStyleInfo;

                if (isFullLine) {
                    // ── Full line — anchor just the line text (no \n) ──
                    // removeType:'fullLine' tells applyAcceptToEditor to delete the whole line
                    fullMatch = line;
                    matchIndex = lineStart;
                    extraStyleInfo = { removeType: 'fullLine' };
                } else {
                    // ── Partial comment — anchor only the % and everything after ──
                    // Trim trailing spaces before the % too
                    const trimmedBefore = beforeComment.trimEnd();
                    const extraSpaces = beforeComment.length - trimmedBefore.length;
                    fullMatch = line.slice(commentIdx - extraSpaces); // spaces + %comment
                    matchIndex = lineStart + commentIdx - extraSpaces;
                    extraStyleInfo = { removeType: 'partial' };
                }

                const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) return;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }

                createAnchor(session, Range, position,
                    fullMatch, '',
                    this.markerClass, this.name, this.description,
                    anchorlist, extraStyleInfo);
            });

            return staleIds;
        }
    },
    PreambleInsertion: {
        name: "Insert Preamble Before Title",
        description: "Automatically inserts default preamble before the first \\title{}",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/preambleBefore.png",
        afterImage: "/images/description/preambleAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const preamble = `\\documentclass[doublecol,final]{epl2}
    
    \\usepackage{amsmath}
    \\usepackage{amssymb}
    \\usepackage{multirow}
    \\usepackage{mathrsfs}
    
    %\\usepackage{showframe}
    %\\usepackage[allfiguresdraft]{draftfigure}
    
    \\usepackage{xcolor}
    
    \\usepackage[bookmarks=false]{hyperref}
    
    \\hypersetup{
    colorlinks=false,
    pdfborder={0 0 0},
    }
    
    \\makeatletter
    \\setlength\\arraycolsep{2pt}
    \\makeatother
    
    \\vol{xx}
    \\issue{xx}
    \\year{2026}
    \\copyyear{2026}
    \\firstpage{1}
    \\doi{10.1209/0295-5075/xx/xxxxx}
    \\pgid{xxxxx}
    \\received{}
    \\acceptedinfinalform{}
    \\paperpub{Xxxx xxxx}
    \\onlinepub{xx Xxxx xxxx}`;

            const staleIds = new Set();

            const titlePattern = /\\title\s*\{/i;
            const match = titlePattern.exec(texFile);
            if (!match) return staleIds;

            const textAboveTitle = texFile.slice(0, match.index);
            const normalize = (str) => str.replace(/\s+/g, ' ').trim();
            if (normalize(textAboveTitle) === normalize(preamble)) return staleIds;

            const titlePos = getPositionFromIndex(texFile, match.index, match[0].length);
            const position = {
                startRow: titlePos.startRow,
                startCol: titlePos.startCol,
                endRow: titlePos.endRow,
                endCol: titlePos.endCol,
            };

            if (isRejectedByLivePosition(position, this.name, match[0])) return staleIds;

            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            }

            createAnchor(
                session, Range,
                position,
                match[0],
                preamble + '\n\n',
                this.markerClass,
                this.name,
                this.description,
                anchorlist,
                {
                    isPreambleInsertion: true,
                    textAboveTitle
                }
            );

            return staleIds;
        }
    },

    removeunwantedtext: {
        name: "Remove \\textcolor{black}",
        description: "Removes the text \\textcolor{black} throughout the body of the document",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/RemoveTextBefore.png",
        afterImage: "/images/description/RemoveTextAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const pattern = /\\textcolor\{black\}/g;
            pattern.lastIndex = 0; // Reset regex to ensure it finds all instances on every check

            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = ""; // Remove by replacing with empty string
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // --- REFRESH / OVERLAP LOGIC ---
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                if (overlapping.length > 0) {
                    // Mark old versions for cleanup to avoid duplicate markers
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    // Skip if the user has already rejected this removal or it's already anchored
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                }

                // Standard check to ignore commented-out code
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
            return staleIds;
        }
    },

    TitleLowerCase: {
        name: "Title Case",
        description: "Capitalize first letter of each word in \\title{}, preserve math and LaTeX commands, skip certain small words. Capitalize after periods.",
        markerClass: "ace-Common-highlight",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const titlePattern = /\\title\s*/gi;
            titlePattern.lastIndex = 0; // Essential for consistent matching during typing

            let match;
            while ((match = titlePattern.exec(texFile)) !== null) {
                const capturedBracedData = texFile.slice(match.index + match[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);

                if (!capturedText) continue;

                const innerContent = capturedText.slice(1, -1);
                // capitalizeInsideBraces handles the logic for small words, math, and periods
                const finalContent = capitalizeInsideBraces(innerContent, true);

                if (finalContent !== innerContent) {
                    const fullMatch = `\\title${capturedText}`;
                    const suggestion = `\\title{${finalContent}}`;
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    // --- REFRESH / OVERLAP LOGIC ---
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        // Mark for refresh so the UI updates to the new capitalized string
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Check if user already saw/rejected this specific casing
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    // Avoid highlighting inside comments
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            suggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },
    shortTitle: {
        name: "Capitalize \\shorttitle",
        description: "Capitalizes \\shorttitle tag (Sentence case), preserves math. If no \\shorttitle, adds one from \\title content.",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/shortTitleBefore.png",
        afterImage: "/images/description/shortTitleAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            // --- Helper: first letter capital, rest lowercase, preserve $math$ ---
            function formatTitle(innerContent) {
                const parts = innerContent.split(/(\$[^$]*\$)/g);
                let firstCharDone = false;
                let finalContent = "";
                for (let i = 0; i < parts.length; i++) {
                    const part = parts[i];
                    if (part.startsWith("$") && part.endsWith("$")) {
                        finalContent += part;
                        continue;
                    }
                    for (let j = 0; j < part.length; j++) {
                        const ch = part[j];
                        if (!firstCharDone && /\S/.test(ch)) {
                            finalContent += ch.toUpperCase();
                            firstCharDone = true;
                        } else {
                            finalContent += ch.toLowerCase();
                        }
                    }
                }
                return finalContent;
            }

            const hasShortTitle = /\\shorttitle\s*/i.test(texFile);

            // --- CASE 1: \shorttitle exists → fix its capitalization ---
            if (hasShortTitle) {
                const shorttitlePattern = /\\shorttitle\s*/gi;
                shorttitlePattern.lastIndex = 0;
                let match;
                while ((match = shorttitlePattern.exec(texFile)) !== null) {
                    const capturedBracedData = texFile.slice(match.index + match[0].length);
                    const capturedText = getInsideTextofBraces(capturedBracedData);
                    if (!capturedText) continue;

                    const innerContent = capturedText.slice(1, -1);
                    const finalContent = formatTitle(innerContent);

                    if (finalContent !== innerContent) {
                        const fullMatch = `\\shorttitle${capturedText}`;
                        const suggestion = `\\shorttitle{${finalContent}}`;
                        const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                        // REFRESH LOGIC
                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                            if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                        }

                        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                            createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
                        }
                    }
                }
                return staleIds;
            }

            // --- CASE 2: No \shorttitle → find \title and add \shorttitle after it ---
            const titlePattern = /\\title\s*/gi;
            titlePattern.lastIndex = 0;
            let tMatch;

            while ((tMatch = titlePattern.exec(texFile)) !== null) {
                const capturedBracedData = texFile.slice(tMatch.index + tMatch[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);
                if (!capturedText) continue;

                const innerContent = capturedText.slice(1, -1);
                const formattedContent = formatTitle(innerContent);

                const originalFull = `\\title${capturedText}`;
                const suggestion = `${originalFull}\n\n\\shorttitle{${formattedContent}}`;
                const position = getPositionFromIndex(texFile, tMatch.index, originalFull.length);

                // REFRESH LOGIC
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, originalFull)) continue;
                    if (isRejectedByLivePosition(position, this.name, originalFull)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session, Range, position,
                        originalFull, suggestion,
                        this.markerClass, this.name,
                        "Add \\shorttitle from \\title content",
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    ChemInsertion: {
        name: "Insert \\chem in title tag",
        description: "Replaces chemical notations (e.g., H$_2$O) in the \\title tag with \\chem{}",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/ChemInsertionBefore.png",
        afterImage: "/images/description/ChemInsertionAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const titlePattern = /\\title\s*/gi;
            titlePattern.lastIndex = 0;

            let match;
            while ((match = titlePattern.exec(texFile)) !== null) {
                const capturedBracedData = texFile.slice(match.index + match[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);

                if (!capturedText) continue;

                let innerContent = capturedText.slice(1, -1);

                /**
                 * Regex Explanation:
                 * ([A-Z][a-z]?)  -> Captures an element (e.g., H, Li, O)
                 * \$_\{?(\d+)\}?\$ -> Captures math subscript (e.g., $_2$ or $_{10}$)
                 * ([A-Z][a-z]*)? -> Captures optional trailing elements (e.g., the 'O' in H$_2$O)
                 */
                const chemRegex = /([A-Z][a-z]?)\$_\{?(\d+)\}?\$([A-Z][a-z]*)?/g;

                let newContent = innerContent.replace(chemRegex, (m, e1, sub, e2) => {
                    const trailing = e2 ? e2 : "";
                    return `\\chem{${e1}_{${sub}}${trailing}}`;
                });

                if (innerContent !== newContent) {
                    const fullMatch = `\\title${capturedText}`;
                    const finalSuggestion = `\\title{${newContent}}`;
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            finalSuggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },
    MathInsertion: {
        name: "Insert \\mth in title tag",
        description: "Replaces the $ signs in the \\title tag with \\mth{}",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/MathInsertionBefore.png",
        afterImage: "/images/description/MathInsertionAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const titlePattern = /\\title\s*/gi;
            titlePattern.lastIndex = 0; // Reset for repeated execution

            let match;
            while ((match = titlePattern.exec(texFile)) !== null) {
                const capturedBracedData = texFile.slice(match.index + match[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);

                if (!capturedText) continue;

                let innerContent = capturedText.slice(1, -1);
                // Replaces $...$ with \mth{...}
                let newContent = innerContent.replace(/\$(.*?)\$/gs, (m, inner) => {
                    return `\\mth{${inner}}`;
                });

                // Only proceed if a replacement actually happened
                if (innerContent !== newContent) {
                    const fullMatch = `\\title${capturedText}`;
                    const finalSuggestion = `\\title{${newContent}}`;
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    // --- REFRESH / OVERLAP LOGIC ---
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        // Mark existing anchor for replacement to prevent flickering
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Logic to ignore already accepted/rejected spots
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    // Final check to ensure we aren't in a commented line
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            finalSuggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },
    authorNaming: {
        name: "Author Initials Formatting",
        description: "Move author initials to the back (e.g., Tiribocchi A.)",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            try {
                const authorPattern = /\\author\s*\{/g;
                let m;

                while ((m = authorPattern.exec(texFile)) !== null) {
                    let depth = 1, i = m.index + m[0].length, content = '';
                    while (i < texFile.length && depth > 0) {
                        if (texFile[i] === '{') depth++;
                        else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                        content += texFile[i]; i++;
                    }
                    const fullMatch = texFile.slice(m.index, i + 1);

                    // Split authors by \and or commas outside braces
                    let authors = content.split(/\\and|,(?![^{]*\})/gi);
                    let needsChange = false;

                    let modifiedAuthors = authors.map(authorStr => {
                        let trimmed = authorStr.trim();

                        /**
                         * IMPROVED REGEX:
                         * Group 1: Matches initials like "A." or "A. B." at start (space optional)
                         * Group 3: Matches the Surname (stops at space, \, or { )
                         */
                        const initialsLeadPattern = /^(([A-Z]\.\s*)+)\s*([^\\{}\s,]+)/;
                        const match = trimmed.match(initialsLeadPattern);

                        if (match) {
                            needsChange = true;
                            // Clean initials to ensure they have a dot and space (e.g., "A. ")
                            let initials = match[1].trim();
                            const surname = match[3].trim();

                            // Replace "A.Tiribocchi" with "Tiribocchi A."
                            // We use a template to ensure a space exists between Surname and Initial
                            return trimmed.replace(match[0], `${surname} ${initials}`);
                        }
                        return authorStr;
                    });

                    if (needsChange) {
                        const finalSuggestion = `\\author{${modifiedAuthors.join(' \\and ')}}`;
                        const position = getPositionFromIndex(texFile, m.index, fullMatch.length);

                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                            if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                            createAnchor(
                                session, Range, position,
                                fullMatch, finalSuggestion,
                                this.markerClass, this.name, this.description, anchorlist
                            );
                        }
                    }
                }
            } catch (err) {
                console.error("Error in authorNaming style:", err);
            }

            return staleIds;
        }
    },
    AuthorFormatting: {
        name: "Author Formatting",
        description: "Add thanks/orcid to the first author and join all authors with \\and",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const authorPattern = /\\author\s*\{/g;
            let m;
            while ((m = authorPattern.exec(texFile)) !== null) {
                // --- 1. Extract Bracketed Content ---
                let depth = 1, i = m.index + m[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(m.index, i + 1);

                // --- 2. Safety Check ---
                // Skip if \thanks is already present to prevent duplicate suggestions
                if (content.includes('\\thanks')) continue;

                // --- 3. Robust Splitting ---
                /**
                 * Regex Explanation:
                 * \\\\and       -> Matches the LaTeX \and command
                 * |             -> OR
                 * ,(?![^{]*\})  -> Matches a comma ONLY if it is not inside { } 
                 * (Prevents breaking \inst{1,2})
                 */
                let authors = content.split(/\\and|,(?![^{]*\})/gi)
                    .map(name => name.trim())
                    .filter(name => name.length > 0);

                if (authors.length === 0) continue;

                // --- 4. Apply Formatting Rules ---
                const thanksContent = `\\thanks{E-mail: \\email{} (corresponding author)}\\orcid{http://orcid.org/}`;

                // Attach thanks/orcid to the first author only
                authors[0] = `${authors[0]}${thanksContent}`;

                // Rejoin everyone using the standard LaTeX \and
                let newAuthorContent = authors.join(' \\and ');

                const finalSuggestion = `\\author{${newAuthorContent}}`;

                // --- 5. Suggestion & Anchor Logic ---
                if (fullMatch !== finalSuggestion) {
                    const position = getPositionFromIndex(texFile, m.index, fullMatch.length);
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    createAnchor(
                        session, Range, position,
                        fullMatch, finalSuggestion,
                        this.markerClass, this.name, this.description, anchorlist
                    );
                }
            }
            return staleIds;
        }
    },
    shortAuthor: {
        name: "Format \\shortauthor",
        description: "Extracts names from \\author, handles 'and' for two, or '\\textit{et al}.' for three+",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            // --- Helper: Clean LaTeX commands out to get raw names ---
            function getCleanedNames(content) {
                let cleaned = content;
                const commandsToRemove = ['\\thanks', '\\orcid', '\\inst', '\\email'];

                commandsToRemove.forEach(cmd => {
                    let idx;
                    while ((idx = cleaned.indexOf(cmd)) !== -1) {
                        const bracePart = getInsideTextofBraces(cleaned.slice(idx + cmd.length));
                        if (bracePart) {
                            cleaned = cleaned.replace(cmd + bracePart, '');
                        } else {
                            cleaned = cleaned.replace(cmd, '');
                        }
                    }
                });

                const names = cleaned.split(/\\and|,/g)
                    .map(n => n.trim())
                    .filter(n => n.length > 0);

                if (names.length === 1) return names[0];
                if (names.length === 2) return `${names[0]} and ${names[1]}`;
                if (names.length >= 3) return `${names[0]} \\textit{et al}.`;
                return "";
            }

            const authorPattern = /\\author\s*\{/g;
            const authorEntries = [];
            let aMatch;
            // Reset lastIndex just in case
            authorPattern.lastIndex = 0;

            while ((aMatch = authorPattern.exec(texFile)) !== null) {
                // FIXED LINE HERE
                const braceData = getInsideTextofBraces(texFile.slice(aMatch.index + aMatch[0].length - 1));
                if (braceData) {
                    authorEntries.push({
                        full: `\\author${braceData}`,
                        content: braceData.slice(1, -1),
                        index: aMatch.index
                    });
                }
            }

            const hasShortAuthor = /\\shortauthor/i.test(texFile);

            if (hasShortAuthor) {
                const shortPattern = /\\shortauthor\s*\{/gi;
                let sMatch;
                while ((sMatch = shortPattern.exec(texFile)) !== null) {
                    const capturedBracedData = getInsideTextofBraces(texFile.slice(sMatch.index + sMatch[0].length - 1));
                    if (!capturedBracedData) continue;

                    const currentShortContent = capturedBracedData.slice(1, -1);
                    const sourceContent = authorEntries.map(e => e.content).join(' \\and ');
                    const formatted = getCleanedNames(sourceContent || currentShortContent);

                    if (formatted && currentShortContent !== formatted) {
                        const originalFull = `\\shortauthor${capturedBracedData}`;
                        const suggestion = `\\shortauthor{${formatted}}`;
                        const pos = getPositionFromIndex(texFile, sMatch.index, originalFull.length);

                        const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(pos, this.name, existingSuggestions, originalFull)) continue;
                            createAnchor(session, Range, pos, originalFull, suggestion, this.markerClass, this.name, this.description, anchorlist);
                        }
                    }
                }
            }
            else if (authorEntries.length > 0) {
                const lastAuthor = authorEntries[authorEntries.length - 1];
                const sourceContent = authorEntries.map(e => e.content).join(' \\and ');
                const formatted = getCleanedNames(sourceContent);

                if (formatted) {
                    const suggestion = `${lastAuthor.full}\n\\shortauthor{${formatted}}`;
                    const pos = getPositionFromIndex(texFile, lastAuthor.index, lastAuthor.full.length);

                    if (!isAlreadyAnchored(pos, this.name, existingSuggestions, lastAuthor.full)) {
                        createAnchor(session, Range, pos, lastAuthor.full, suggestion, this.markerClass, this.name, "Add missing \\shortauthor", anchorlist);
                    }
                }
            }

            return staleIds;
        }
    },
    FormatAnd: {
        name: "Add \\and in \\author",
        description: "Replaces 'and' in the \\author tag with \\and if not already escaped",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/FormatandBefore.png",
        afterImage: "/images/description/FormatandAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            const authorPattern = /\\author(\[[^\]]*\])?\s*/gi;
            authorPattern.lastIndex = 0; // Reset regex state

            let match;
            while ((match = authorPattern.exec(texFile)) !== null) {
                const capturedBracedData = texFile.slice(match.index + match[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);

                if (!capturedText) continue;

                const innerContent = capturedText.slice(1, -1);
                // Matches " and " or ", and " but not "\and"
                const newContent = innerContent.replace(
                    /(?<!\\)(?<=\W),?\s?and(?=\W)/g,
                    " \\and "
                );

                // Only proceed if a replacement actually happened
                if (innerContent !== newContent) {
                    const fullMatch = match[0] + capturedText;
                    const finalSuggestion = `\\author${match[1] || ""}{${newContent}}`;
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    // --- REFRESH / OVERLAP LOGIC ---
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        // Mark for refresh
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Standard guard checks
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    // Ensure we aren't in a comment
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            finalSuggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },
    AddInstituteTag: {
        name: "Address/Affiliation to \\inst{}",
        description: "Modifies address/affiliation into \\inst{} and wraps them in \\institute{}",
        markerClass: "ace-Common-highlight",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            // --- CASE 1: \institute already exists (Formatting Check) ---
            if (/\\institute/.test(texFile)) {
                const institutePattern = /\\institute\s*/gi;
                let match;
                while ((match = institutePattern.exec(texFile)) !== null) {
                    const capturedBracedData = texFile.slice(match.index + match[0].length);
                    const capturedText = getInsideTextofBraces(capturedBracedData);

                    if (capturedText) {
                        const innerContent = capturedText.slice(1, -1);
                        const suggestion = `\\institute{\n${innerContent}\n}`;
                        const fullMatch = match[0] + capturedText;
                        const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                        // --- REFRESH LOGIC ---
                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                            if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                        }

                        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                            createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
                        }
                    }
                }
                return staleIds;
            }

            // --- CASE 2: Convert \address / \affiliation to \institute ---
            if (/(\\affiliation|\\address|\\affili)/.test(texFile)) {
                const affPattern = /(\\affiliation|\\address|\\affili)\s*/gi;
                const instValues = [];
                const affMatches = [];
                let match;

                while ((match = affPattern.exec(texFile)) !== null) {
                    const capturedBracedData = texFile.slice(match.index + match[0].length);
                    const capturedText = getInsideTextofBraces(capturedBracedData);

                    if (capturedText) {
                        const innerContent = capturedText.slice(1, -1);
                        instValues.push(innerContent);
                        affMatches.push({
                            index: match.index,
                            fullMatch: match[0] + capturedText,
                            length: match[0].length + capturedText.length
                        });
                    }
                }

                if (instValues.length === 0 || affMatches.length === 0) return staleIds;

                const instituteLines = instValues.map((value, idx) => `\\inst{${idx + 1}} ${value}`);
                const newInstitute = `\\institute{\n${instituteLines.join("\n")}\n}`;

                const firstAff = affMatches[0];
                const lastAff = affMatches[affMatches.length - 1];
                const startIndex = firstAff.index;
                const endIndex = lastAff.index + lastAff.length;
                const originalText = texFile.slice(startIndex, endIndex);

                const position = getPositionFromIndex(texFile, startIndex, originalText.length);

                // --- REFRESH LOGIC FOR CONVERSION ---
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, originalText)) return staleIds;
                    if (isRejectedByLivePosition(position, this.name, originalText)) return staleIds;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, originalText, newInstitute, this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    footNote: {
        name: "Remove space before \\footnote",
        description: "Removes any whitespace (spaces or tabs) before the \\footnote tag.",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/footNoteBefore.png",
        afterImage: "/images/description/footNoteAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            // Regex: matches 1 or more spaces/tabs followed by \footnote{...}
            // Note: handles nested braces slightly more robustly with [^{}]*
            const footnotePattern = /[ \t]+\\footnote\{((?:[^{}]*\{[^{}]*\})*[^{}]*)\}/g;
            footnotePattern.lastIndex = 0;

            let match;
            while ((match = footnotePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const content = match[1];

                const suggestion = `\\footnote{${content}}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // --- REFRESH / OVERLAP LOGIC ---
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                if (overlapping.length > 0) {
                    // Mark old versions as stale so they are redrawn
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    // Standard guards for new suggestions
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                }

                // Ensure we aren't matching inside a comment or another command
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    SIUnitStyling: {
        name: "Enclose SIUnit with \\un{}",
        description: "Wraps SI units in \\un{} and removes space between number and unit, number remains outside.",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/SIUnitStylingBefore.png",
        afterImage: "/images/description/SIUnitStylingAfter.png",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            const baseUnits = [
                'm', 'g', 'kg', 's', 'A', 'K', 'mol', 'cd',
                'Hz', 'N', 'Pa', 'J', 'W', 'C', 'V', 'F', 'Ω', 'S', 'Wb', 'T', 'H',
                'rad', 'sr', 'lm', 'lx', 'Bq', 'Gy', 'Sv', 'kat',
                'mm', 'cm', 'km', 'mg', 'μg', 'ng', 'ms', 'μs', 'ns', 'mA', 'μA',
                'kHz', 'MHz', 'GHz', 'mV', 'kV', 'MV', 'mW', 'kW', 'MW',
                'eV', 'keV', 'MeV', 'GeV',
                'L', 'mL', 'dB', 'u', 'Da', 'kDa'
            ];

            const unitPattern = baseUnits.join('|');
            const compoundUnitPattern = `(?:${unitPattern})(?:[\\\\/·\\\\.](?:${unitPattern}))*`;

            // Regex Breakdown:
            // Group 1: ([^\w\\]) -> Prefix (non-word, non-backslash)
            // Group 2: (\d+(?:\.\d+)?) -> The Number
            // Group 3: \s*~*\s* -> Potential spaces or tildes
            // Group 4: (compoundUnitPattern) -> The actual Unit
            // Group 5: ([. /]|$) -> The trailing character or end of string
            const siUnitRegex = new RegExp(`([^\\w\\\\])(\\d+(?:\\.\\d+)?)\\s*~*\\s*(${compoundUnitPattern})([. /]|$)`, 'gm');
            siUnitRegex.lastIndex = 0; // Reset regex state

            let match;
            while ((match = siUnitRegex.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const prefix = match[1];
                const number = match[2];
                const unit = match[3];
                const trailing = match[4];

                // Guard: Skip if already wrapped in \un{
                // We check a small slice before the match index
                const contextBefore = texFile.substring(Math.max(0, match.index - 4), match.index);
                if (contextBefore.includes('\\un{')) continue;

                const suggestion = `${prefix}${number}\\un{${unit}}${trailing}`;
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // --- REFRESH / OVERLAP LOGIC ---
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    // Renew the anchor to prevent flickering
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    // Standard guards for new anchors
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                }

                // Final check: Is this inside a LaTeX command?
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    BeginEquation: {
        name: "\\begin{equation}",
        description: "Add labels to equations without labels, remove labels from unnumbered equations",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const filename = (fileName || "doc").replace(/\.tex$/i, '');

            function isCommented(text, index) {
                let lineStart = index;
                while (lineStart > 0 && text[lineStart - 1] !== '\n') lineStart--;
                for (let i = lineStart; i < index; i++) {
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                }
                return false;
            }

            const equationPattern = /\\begin\s*\{(equation|align|eqnarray|gather|multline)\s*(\*?)\}([\s\S]*?)\\end\s*\{\1\s*\2\}/g;
            let match;
            let numberedEqnCounter = 1;

            while ((match = equationPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const envName = match[1];
                const isUnnumbered = match[2] === '*';
                const envBody = match[3];
                const matchIndex = match.index;

                if (isCommented(texFile, matchIndex)) continue;

                const firstNewline = fullMatch.indexOf('\n');
                const firstline = firstNewline !== -1 ? fullMatch.slice(0, firstNewline) : fullMatch;

                const labelPattern = /\\label\{([^}]*)\}/gi;
                let labelMatch;
                let hasLabel = false;
                while ((labelMatch = labelPattern.exec(envBody)) !== null) {
                    if (!isCommented(envBody, labelMatch.index)) { hasLabel = true; break; }
                }

                if (isUnnumbered) {
                    if (hasLabel) {
                        const labelText = labelMatch[0];
                        const labelIndex = matchIndex + fullMatch.indexOf(labelText);
                        const position = getPositionFromIndex(texFile, labelIndex, labelText.length);

                        if (isRejectedByLivePosition(position, this.name, labelText)) continue;
                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                        }
                        createAnchor(session, Range, position,
                            labelText, '',
                            this.markerClass, this.name,
                            'Remove label from unnumbered equation',
                            anchorlist);
                    }
                } else {
                    if (!hasLabel) {
                        const expectedLabel = `${filename}eqn${numberedEqnCounter}`;
                        const position = getPositionFromIndex(texFile, matchIndex, firstline.length);
                        const suggestion = `${firstline}\n\\label{${expectedLabel}}`;

                        if (isRejectedByLivePosition(position, this.name, firstline)) {
                            numberedEqnCounter++; continue;
                        }
                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) {
                                numberedEqnCounter++; continue;
                            }
                        }
                        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                            createAnchor(session, Range, position,
                                firstline, suggestion,
                                this.markerClass, this.name,
                                `Add label ${expectedLabel} after \\begin{${envName}}`,
                                anchorlist);
                        }
                        numberedEqnCounter++;
                    }
                }
            }

            return staleIds;
        }
    },

    BeginTable: {
        name: "\\begin{table}",
        description: "Add labels to tables without labels",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const filename = (fileName || "doc").replace(/\.tex$/i, '');

            function isCommented(text, index) {
                let lineStart = index;
                while (lineStart > 0 && text[lineStart - 1] !== '\n') lineStart--;
                for (let i = lineStart; i < index; i++) {
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                }
                return false;
            }

            const tablePattern = /\\begin\s*\{table\*?\}([\s\S]*?)\\end\{table\*?\}/gi;
            const nestedPattern = /\\begin\s*\{table/gi;
            let match;
            let tableCounter = 1;

            while ((match = tablePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const tableBody = match[1];
                const beginIndex = match.index;

                if (tableBody.match(nestedPattern)) continue;
                if (isCommented(texFile, beginIndex)) continue;

                const firstNewline = fullMatch.indexOf('\n');
                const firstline = firstNewline !== -1 ? fullMatch.slice(0, firstNewline) : fullMatch;

                const labelPattern = /\\label\{([^}]*)\}/gi;
                let labelMatch;
                let hasLabel = false;
                while ((labelMatch = labelPattern.exec(tableBody)) !== null) {
                    if (!isCommented(tableBody, labelMatch.index)) { hasLabel = true; break; }
                }

                if (!hasLabel) {
                    const expectedLabel = `${filename}tab${tableCounter}`;
                    const position = getPositionFromIndex(texFile, beginIndex, firstline.length);
                    const suggestion = `${firstline}\n\\label{${expectedLabel}}`;

                    if (isRejectedByLivePosition(position, this.name, firstline)) {
                        tableCounter++; continue;
                    }
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) {
                            tableCounter++; continue;
                        }
                    }
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(session, Range, position,
                            firstline, suggestion,
                            this.markerClass, this.name,
                            `Add label ${expectedLabel} after \\begin{table}`,
                            anchorlist);
                    }
                }
                tableCounter++;
            }

            return staleIds;
        }
    },

    BeginFigure: {
        name: "\\begin{figure}",
        description: "Add labels and fix \\includegraphics filenames in figures",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const filename = (fileName || "doc").replace(/\.tex$/i, '');

            function isCommented(text, index) {
                let lineStart = index;
                while (lineStart > 0 && text[lineStart - 1] !== '\n') lineStart--;
                for (let i = lineStart; i < index; i++) {
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                }
                return false;
            }

            const figurePattern = /\\begin\{figure\*?\}([\s\S]*?)\\end\{figure\*?\}/gi;
            let match;
            let figureCounter = 1;

            while ((match = figurePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const figureBody = match[1];
                const matchIndex = match.index;

                if (isCommented(texFile, matchIndex)) continue;

                const firstNewline = fullMatch.indexOf('\n');
                const firstline = firstNewline !== -1 ? fullMatch.slice(0, firstNewline) : fullMatch;

                // ── 1. Label check ──
                const labelPattern = /\\label\{([^}]*)\}/gi;
                let labelMatch;
                let hasLabel = false;
                while ((labelMatch = labelPattern.exec(figureBody)) !== null) {
                    if (!isCommented(figureBody, labelMatch.index)) { hasLabel = true; break; }
                }

                if (!hasLabel) {
                    const expectedLabel = `${filename}fig${figureCounter}`;
                    const position = getPositionFromIndex(texFile, matchIndex, firstline.length);
                    const suggestion = `${firstline}\n\\label{${expectedLabel}}`;

                    if (!isRejectedByLivePosition(position, this.name, firstline)) {
                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else if (!isAlreadyAnchored(position, this.name, existingSuggestions)) {
                            if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                                createAnchor(session, Range, position,
                                    firstline, suggestion,
                                    this.markerClass, this.name,
                                    `Add label ${expectedLabel} after \\begin{figure}`,
                                    anchorlist);
                            }
                        }
                    }
                }

                // ── 2. \includegraphics filename check ──
                // Expected filename pattern: filename + fig + counter (e.g. doc1, doc2)
                const includePattern = /\\includegraphics\s*(?:\[[^\]]*\])?\s*\{([^}]*)\}/g;
                let includeMatch;
                let includeCounter = 1; // if multiple includes in one figure

                while ((includeMatch = includePattern.exec(figureBody)) !== null) {
                    if (isCommented(figureBody, includeMatch.index)) continue;

                    const currentFile = includeMatch[1].trim();
                    // Extract just the name without extension
                    const currentBase = currentFile.replace(/\.[^.]+$/, '');

                    // Expected base: filename + figureCounter (e.g. "doc1" for fig 1)
                    // const expectedBase = `${filename}${figureCounter}`;
                    const expectedBase = `${filename}_f${figureCounter}_pr`;

                    // Skip if already matches expected pattern
                    if (currentBase === expectedBase) { includeCounter++; continue; }

                    const fullInclude = includeMatch[0];
                    const includeAbsIdx = matchIndex + fullMatch.indexOf(figureBody) + includeMatch.index;

                    // Keep original extension if present, else no extension
                    const ext = currentFile.match(/\.[^.]+$/)?.[0] || '';
                    // const newInclude = fullInclude.replace(
                    //     /(\{)[^}]*(\})/,
                    //     `$1${expectedBase}${ext}$2`
                    // );
                    const newInclude = fullInclude.replace(
                        /(\{)[^}]*(\})/,
                        `$1${expectedBase}${ext}$2`
                    );

                    const inclPosition = getPositionFromIndex(texFile, includeAbsIdx, fullInclude.length);

                    if (isRejectedByLivePosition(inclPosition, this.name + '_include', fullInclude)) {
                        includeCounter++; continue;
                    }

                    const inclOverlap = getOverlappingAnchors(
                        inclPosition, this.name + '_include', existingSuggestions
                    );
                    if (inclOverlap.length > 0) {
                        inclOverlap.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(inclPosition, this.name + '_include', existingSuggestions)) {
                            includeCounter++; continue;
                        }
                    }

                    if (!findCommandorNot(inclPosition.startRow, inclPosition.startCol, texFile)) {
                        createAnchor(session, Range, inclPosition,
                            fullInclude, newInclude,
                            this.markerClass,
                            this.name + '_include',
                            `Rename \\includegraphics file to ${expectedBase}${ext}`,
                            anchorlist);
                    }
                    includeCounter++;
                }

                figureCounter++;
            }

            return staleIds;
        }
    },
    properLabelRef: {
        name: "Proper Label and Ref",
        description: "Rename labels to match filename:typeN format and update all refs",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const filename = (fileName || "doc").replace(/\.tex$/i, '');

            const envTypeMap = {
                'equation': 'eqn',
                'align': 'arrayeqn',
                'eqnarray': 'arrayeqn',
                'gather': 'arrayeqn',
                'multline': 'arrayeqn',
                'figure': 'fig',
                'figure*': 'fig',
                'table': 'tab',
                'table*': 'tab',
                'algorithm': 'alg',
                'listing': 'lst',
            };

            function isCommented(text, index) {
                let lineStart = index;
                while (lineStart > 0 && text[lineStart - 1] !== '\n') lineStart--;
                for (let i = lineStart; i < index; i++) {
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                }
                return false;
            }

            const envPattern = /\\begin\s*\{(equation|align|eqnarray|gather|multline|figure\*?|table\*?|algorithm|listing)\s*(\*?)\}([\s\S]*?)\\end\s*\{\1\s*\2\}/g;
            const typeCounters = {};
            const collected = [];
            let match;

            while ((match = envPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const envName = match[1];
                const isUnnumbered = match[2] === '*' || envName.endsWith('*');
                const envBody = match[3];
                const matchIndex = match.index;

                if (isCommented(texFile, matchIndex)) continue;
                if (isUnnumbered) continue;

                const typePrefix = envTypeMap[envName];
                if (!typePrefix) continue;

                if (!typeCounters[typePrefix]) typeCounters[typePrefix] = 0;
                typeCounters[typePrefix]++;
                const expectedLabel = `${filename}${typePrefix}${typeCounters[typePrefix]}`;

                const labelPattern = /\\label\{([^}]*)\}/gi;
                let labelMatch = null, tempMatch;
                while ((tempMatch = labelPattern.exec(envBody)) !== null) {
                    if (!isCommented(envBody, tempMatch.index)) { labelMatch = tempMatch; break; }
                }

                collected.push({ fullMatch, envName, envBody, matchIndex, expectedLabel, labelMatch });
            }

            for (const env of collected) {
                const { fullMatch, envName, matchIndex, expectedLabel, labelMatch } = env;

                if (labelMatch) {
                    const currentLabelName = labelMatch[1];
                    if (currentLabelName === expectedLabel) continue;

                    const labelText = labelMatch[0];
                    const labelIndex = matchIndex + fullMatch.indexOf(labelText);
                    const position = getPositionFromIndex(texFile, labelIndex, labelText.length);

                    if (isRejectedByLivePosition(position, this.name, labelText)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    createAnchor(session, Range, position,
                        labelText, `\\label{${expectedLabel}}`,
                        this.markerClass, this.name,
                        `Rename \\label{${currentLabelName}} → \\label{${expectedLabel}}`,
                        anchorlist,
                        { oldLabelName: currentLabelName, newLabelName: expectedLabel }
                    );

                } else {
                    const firstNewline = fullMatch.indexOf('\n');
                    const firstLine = firstNewline !== -1 ? fullMatch.slice(0, firstNewline) : fullMatch;
                    const position = getPositionFromIndex(texFile, matchIndex, firstLine.length);
                    const suggestion = `${firstLine}\n\\label{${expectedLabel}}`;

                    if (isRejectedByLivePosition(position, this.name, firstLine)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(session, Range, position,
                            firstLine, suggestion,
                            this.markerClass, this.name,
                            `Add \\label{${expectedLabel}} to \\begin{${envName}}`,
                            anchorlist,
                            { oldLabelName: null, newLabelName: expectedLabel }
                        );
                    }
                }
            }

            return staleIds;
        }
    },
    FormatExample: {
        name: "Format e.g, i.e and et al",
        description: "Formats e.g, i.e to italics and et al with \\etal",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/FormatExampleBefore.png",
        afterImage: "/images/description/FormatExampleAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();
            const mappings = [
                { pattern: /\be\.g\./g, suggestion: '\\textit{e.g.}' },
                { pattern: /\be\.g\b/g, suggestion: '\\textit{e.g.}' },
                { pattern: /\bi\.e\./g, suggestion: '\\textit{i.e.}' },
                { pattern: /\bi\.e\b/g, suggestion: '\\textit{i.e.}' },
                { pattern: /\bet al\./g, suggestion: '{\\etal}' },
                { pattern: /\bet al\b/g, suggestion: '{\\etal}' },
            ];

            const alreadyWrapped = (texFile, matchIndex, fullMatch) => {
                const before = texFile.substring(Math.max(0, matchIndex - 9), matchIndex);
                if (before.endsWith('\\textit{')) return true;

                const surroundCheck = texFile.substring(Math.max(0, matchIndex - 7), matchIndex + fullMatch.length + 2);
                if (surroundCheck.includes('\\etal')) return true;

                return false;
            };

            for (const { pattern, suggestion } of mappings) {
                pattern.lastIndex = 0;
                let match;
                while ((match = pattern.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const matchIndex = match.index;

                    if (alreadyWrapped(texFile, matchIndex, fullMatch)) continue;
                    if (fullMatch.includes('\n')) continue;

                    const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

                    // ── NEW LOGIC: Stale & Overlapping Check ──
                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        // Mark old versions of this suggestion as stale so they are refreshed
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Check if this specific suggestion already exists to avoid duplicates
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session, Range, position,
                            fullMatch, suggestion,
                            this.markerClass, this.name,
                            this.description, anchorlist
                        );
                    }
                }
            }
            return staleIds; // Essential for the proper method
        }
    },
    CitationStyling: {
        name: "Citation Styling",
        description: "Updates citation references to match bibitem labels",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const filename = (fileName || "doc").replace(/\.tex$/i, '');

            const bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)\\end\{thebibliography\}/;
            const bibMatch = bibliographyPattern.exec(texFile);
            if (!bibMatch || !/\\bib[a-z]{0,5}em\{/.test(bibMatch[0])) return staleIds;

            const bibSection = bibMatch[0];
            const bibSectionIndex = bibMatch.index;
            let bibCounter = 1;
            const labelMap = {};

            const currentFileObj = Array.isArray(Allfiles?.data)
                ? Allfiles.data.find(f => f.name === fileName)
                : null;
            const currentFileUuid = currentFileObj?.file_uuid || null;

            // ── Pass 1: \bibitem anchors ──
            const bibitemPattern = /\\bib[a-z]{0,5}em\{([^}]*)\}/g;
            let match;

            while ((match = bibitemPattern.exec(bibSection)) !== null) {
                const fullMatch = match[0];
                const oldKey = match[1];
                const newKey = `${filename}bib${bibCounter}`;
                const matchIndex = bibSectionIndex + match.index;

                labelMap[oldKey] = newKey;

                const isExactBibitem = fullMatch.startsWith('\\bibitem{');
                if (isExactBibitem && oldKey !== newKey) {
                    const suggestion = `\\bibitem{${newKey}}`;
                    const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

                    if (isRejectedByLivePosition(position, this.name, fullMatch)) {
                        bibCounter++; continue;
                    }

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) {
                            bibCounter++; continue;
                        }
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(session, Range, position,
                            fullMatch, suggestion,
                            this.markerClass, this.name,
                            `Update bibitem label to ${newKey}`,
                            anchorlist,
                            {
                                isBibitemKeyChange: true,
                                oldKey,
                                newKey,
                                allfiles: Allfiles,
                                currentFileUuid,
                            }
                        );
                    }
                }
                bibCounter++;
            }

            // ── Pass 2: \cite anchors ──
            const citePattern = /(\s*)~?\\cite\{([^}]*)\}/g;
            citePattern.lastIndex = 0;

            while ((match = citePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const citeLabels = match[2];
                const matchIndex = match.index;

                const refs = citeLabels.split(',').map(r => r.trim().replace(/\n/g, ''));
                const newRefs = refs.map(r => labelMap[r] || r);
                if (!refs.some((r, i) => newRefs[i] !== r)) continue;

                const suggestion = `~\\cite{${newRefs.join(',')}}`;
                const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name,
                        'Update citation reference and ensure proper spacing',
                        anchorlist);
                }
            }

            return staleIds;
        }
    },
    BibitemFormatConvert: {
        name: "Bibitem Format Convert",
        description: "Converts \\bibitem entries from doc-style to EPL-style",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)\\end\{thebibliography\}/;
            const bibMatch = bibliographyPattern.exec(texFile);
            if (!bibMatch || !bibMatch[0].includes('\\bibitem')) return staleIds;

            const bibSection = bibMatch[0];
            const bibSectionIndex = bibMatch.index;

            // ── Helper: Converts "J. Smith" to "Smith J." ──
            function convertSingleAuthor(raw) {
                raw = raw.trim();
                const normalised = raw.replace(/~/g, ' ');
                const tokens = normalised.split(/\s+/).filter(Boolean);
                const initials = [];
                let lastName = null;

                for (const token of tokens) {
                    // Identify initials (e.g., "A." or "J.-P.")
                    if (/^[A-Z][\w-]*\.$/.test(token)) {
                        initials.push(token);
                    } else {
                        lastName = token; // Assume the last non-period token is the surname
                    }
                }

                if (!lastName) return raw;
                const initialsStr = initials.join('~');
                return initialsStr ? `${lastName} ${initialsStr}` : lastName;
            }

            // ── Helper: Handles "Author A, Author B and Author C" ──
            function buildNameField(scContent) {
                // Standardize separators: change "and" to comma
                let content = scContent.replace(/\band\b/g, ',');
                const authors = content.split(',').map(p => p.trim()).filter(Boolean);

                const converted = authors.map(convertSingleAuthor);
                if (converted.length === 0) return null;
                if (converted.length === 1) return converted[0];

                // EPL Style uses \and for the final joiner
                return converted.slice(0, -1).join(', ') + ' \\and ' + converted[converted.length - 1];
            }

            // ── Helper: Extracts Journal, Vol, Year, Page ──
            function buildReviewField(rest) {
                if (!rest) return null;
                rest = rest.trim().replace(/\.\s*$/, '');

                // Regex Update: Added (?:pp?\.?\s*~?)? to make "p." or "pp." optional
                const m = rest.match(/^(.*?),\s*(\d+)\s*\((\d{4})\),?\s*(?:pp?\.?\s*~?)?(\d+)/);
                if (!m) return null;

                return `\\REVIEW{${m[1].trim()}}{${m[2]}}{${m[3]}}{${m[4]}}`;
            }

            const rawBlocks = bibSection
                .split(/(?=\\bib[a-z]{0,5}em\{)|(?=\\end\{thebibliography\})/)
                .filter(s => s.trim());

            let runningOffset = 0;

            for (const block of rawBlocks) {
                if (!/^\\bib[a-z]{0,5}em\{/.test(block)) {
                    runningOffset += block.length; continue;
                }

                const isExactBibitem = block.startsWith('\\bibitem{');
                const keyMatch = block.match(/^\\bib[a-z]{0,5}em\{([^}]*)\}([\s\S]*)/);
                if (!keyMatch || !isExactBibitem) { runningOffset += block.length; continue; }

                const bibKey = keyMatch[1];
                const rawBody = keyMatch[2].replace(/\s+$/, '');
                const flatBody = rawBody.replace(/\s+/g, ' ').trim();
                const absoluteIndex = bibSectionIndex + runningOffset;

                // Extract the Small Caps (Authors) and Emphasis (Journal) parts
                const scMatch = flatBody.match(/\{\\sc\s+([\s\S]*?)\}/);
                const emMatch = flatBody.match(/\{\\em\s+([\s\S]*?)\}\s*,?\s*([\s\S]*)/);

                if (!scMatch && !emMatch) { runningOffset += block.length; continue; }

                let journalRest = emMatch
                    ? `${emMatch[1]}, ${emMatch[2]}`.trim()
                    : flatBody.replace(/\{\\sc\s+[\s\S]*?\}/, '').replace(/^\s*,?\s*/, '').trim();

                const nameField = scMatch ? buildNameField(scMatch[1].trim()) : null;
                const reviewField = buildReviewField(journalRest);

                if (!nameField && !reviewField) { runningOffset += block.length; continue; }

                // Construct the EPL suggestion
                let suggestion = `\\bibitem{${bibKey}}\n`;
                if (nameField && reviewField) {
                    suggestion += `\\Name{${nameField}},\n${reviewField}.`;
                } else if (nameField) {
                    suggestion += `\\Name{${nameField}},`;
                } else {
                    suggestion += `${reviewField}.`;
                }

                const originalFull = `\\bibitem{${bibKey}}${rawBody}`;
                const position = getPositionFromIndex(texFile, absoluteIndex, originalFull.length);

                // ── Standard Validation Guards ──
                if (isRejectedByLivePosition(position, this.name, originalFull)) {
                    runningOffset += block.length; continue;
                }

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else if (isAlreadyAnchored(position, this.name, existingSuggestions)) {
                    runningOffset += block.length; continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        originalFull, suggestion,
                        this.markerClass, this.name,
                        'Convert bibitem to EPL \\Name + \\REVIEW format',
                        anchorlist);
                }

                runningOffset += block.length;
            }

            return staleIds;
        }
    },
  
    abstractUnifiedStyling: {
        name: "Standardize Abstract to Command",
        description: "Converts abstract environment to command and ensures ~ formatting while preserving line breaks.",
        markerClass: "ace-Common-highlight",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;
    
            // 1. Handle the Environment: \begin{abstract} ... \end{abstract}
            const envPattern = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/g;
            let envMatch;
            while ((envMatch = envPattern.exec(texFile)) !== null) {
                const fullMatch = envMatch[0];
                const innerContent = envMatch[1];
                
                // Clean text: remove leading ~ and trim edges, but KEEP internal \n
                const cleanText = innerContent.replace(/^~/, '').trim();
                const suggestion = `\\abstract{~${cleanText}}`;
    
                this.applyLogic(fullMatch, suggestion, envMatch.index, texFile, session, Range, anchorlist, existingSuggestions, staleIds);
            }
    
            // 2. Handle the existing Command: \abstract{...}
            const cmdPattern = /\\abstract\s*/g;
            let cmdMatch;
            while ((cmdMatch = cmdPattern.exec(texFile)) !== null) {
                const context = texFile.slice(Math.max(0, cmdMatch.index - 10), cmdMatch.index);
                if (context.includes("begin")) continue;
    
                const capturedBracedData = texFile.slice(cmdMatch.index + cmdMatch[0].length);
                const capturedText = getInsideTextofBraces(capturedBracedData);
                if (!capturedText) continue;
    
                const innerContent = capturedText.slice(1, -1);
                
                // Clean text: remove leading ~ and trim edges, but KEEP internal \n
                const cleanText = innerContent.replace(/^~/, '').trim();
                const formattedInner = `~${cleanText}`;
    
                // Only trigger if it doesn't start with ~ or has messy edges
                if (innerContent !== formattedInner) {
                    const fullMatch = `\\abstract${capturedText}`;
                    const suggestion = `\\abstract{${formattedInner}}`;
                    this.applyLogic(fullMatch, suggestion, cmdMatch.index, texFile, session, Range, anchorlist, existingSuggestions, staleIds);
                }
            }
            return staleIds;
        },
    
        applyLogic: function (fullMatch, suggestion, index, texFile, session, Range, anchorlist, existingSuggestions, staleIds) {
            const position = getPositionFromIndex(texFile, index, fullMatch.length);
            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) return;
                if (isRejectedByLivePosition(position, this.name, fullMatch)) return;
            }
    
            if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
            }
        }
    },
    insertBeginDocument: {
        name: "Insert \\begin{document}",
        description: "Ensures \\maketitle appears right after \\begin{document}.",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/BeginDocumentBefore.png",
        afterImage: "/images/description/BeginDocumentAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const beginDocPattern = /\\begin\{document\}/g;
            const maketitlePattern = /\\maketitle/g;

            const beginDocMatch = beginDocPattern.exec(texFile);
            const maketitleMatch = maketitlePattern.exec(texFile);

            // If no \begin{document}, we can't reliably place \maketitle
            if (!beginDocMatch) return staleIds;

            const beginDocIndex = beginDocMatch.index;
            const beginDocText = beginDocMatch[0];
            const afterBeginDoc = texFile.slice(beginDocIndex + beginDocText.length);

            // Check if \maketitle is already correctly placed (first non-whitespace)
            const isCorrectlyPlaced = /^\s*\\maketitle/.test(afterBeginDoc);

            // If it's already correct, do nothing
            if (isCorrectlyPlaced) return staleIds;

            // If we get here, \maketitle is either missing or misplaced somewhere else
            const pos = getPositionFromIndex(texFile, beginDocIndex, beginDocText.length);
            const position = {
                startRow: pos.startRow,
                startCol: pos.startCol,
                endRow: pos.endRow,
                endCol: pos.endCol,
            };

            // CRITICAL: Check if we already have an anchor at this \begin{document}
            if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            if (isRejectedByLivePosition(position, this.name, beginDocText)) return staleIds;

            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            }

            // Create the anchor with the styleInfo metadata
            createAnchor(
                session, Range, position,
                beginDocText,
                `\\begin{document}\n\\maketitle`, // Suggestion
                this.markerClass, this.name, this.description,
                anchorlist,
                {
                    name: this.name, // Fixes the "undefined" style name issue
                    maketitleAction: 'moveAndClean',
                    oldMaketitleIndex: maketitleMatch ? maketitleMatch.index : null
                }
            );

            return staleIds;
        }
    },
    AdjustMathBrackets: {
        name: "Adjust Math Brackets",
        description: "Add \\left and \\right to brackets enclosing math constructs inside equation environments only",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/AdjustBracketBefore.png",
        afterImage: "/images/description/AdjustBracketAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();
            const equationPattern = /\\begin\{equation\}([\s\S]*?)\\end\{equation\}/g;
            const targets = "\\\\(frac|sum|int|prod)";
            const rules = [
                { pattern: new RegExp(`(?<!\\\\left)\\(([^()]*${targets}[\\s\\S]*?)\\)`, "g"), wrap: (inner) => `\\left(${inner}\\right)` },
                { pattern: new RegExp(`(?<!\\\\left)\\\\\\{([^{}]*${targets}[\\s\\S]*?)\\\\\\}`, "g"), wrap: (inner) => `\\left\\{${inner}\\right\\}` },
                { pattern: new RegExp(`(?<!\\\\left)\\[([^\\[\\]]*${targets}[\\s\\S]*?)\\]`, "g"), wrap: (inner) => `\\left[${inner}\\right]` },
                { pattern: new RegExp(`(?<!\\\\left)\\|([^|]*${targets}[\\s\\S]*?)\\|`, "g"), wrap: (inner) => `\\left|${inner}\\right|` },
            ];

            let eqMatch;
            while ((eqMatch = equationPattern.exec(texFile)) !== null) {
                const equationBody = eqMatch[1];
                const equationStartIndex = eqMatch.index + eqMatch[0].indexOf(equationBody);

                for (const { pattern, wrap } of rules) {
                    pattern.lastIndex = 0;
                    let match;
                    while ((match = pattern.exec(equationBody)) !== null) {
                        const fullMatch = match[0];
                        const suggestion = wrap(match[1]);
                        const absoluteIndex = equationStartIndex + match.index;
                        const position = getPositionFromIndex(texFile, absoluteIndex, fullMatch.length);

                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                        const overlapping = getOverlappingAnchors(position, this.name,
                            existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                        }

                        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                            createAnchor(session, Range, position, fullMatch, suggestion,
                                this.markerClass, this.name, this.description, anchorlist);
                        }
                    }
                }
            }

            return staleIds;
        }
    },
    figureRefStandardization: {
        name: "Figure Reference Formatting",
        description: "Standardize (Figure \\ref...) to (Fig. \\ref...) with correct sub-ref parentheses (a)--(c)",
        markerClass: "ace-Common-highlight",
        execute: function (texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            if (!texFile) return staleIds;

            // Reset lastIndex is crucial for consistent matching during typing
            const figPattern = /\((?:Figure|Fig\.)\s+\\ref\{([^}]+)\}([^)]*)\)/g;
            figPattern.lastIndex = 0;

            let m;
            while ((m = figPattern.exec(texFile)) !== null) {
                const fullMatch = m[0];
                const label = m[1];
                const subRefsRaw = m[2];

                // 1. CLEANING LOGIC: Extract only the letters (a, b, c...)
                const letters = subRefsRaw
                    .replace(/\band\b/gi, '')
                    .replace(/[^a-zA-Z]/g, '')
                    .split('')
                    .filter(Boolean);

                let formattedSubRef = "";

                // 2. FORMATTING LOGIC
                if (letters.length === 1) {
                    formattedSubRef = `(${letters[0]})`;
                }
                else if (letters.length === 2) {
                    formattedSubRef = `(${letters[0]})(${letters[1]})`;
                }
                else if (letters.length > 2) {
                    const start = letters[0];
                    const end = letters[letters.length - 1];
                    formattedSubRef = `(${start})--(${end})`;
                }

                const suggestion = `(Fig. \\ref{${label}}${formattedSubRef})`;

                // 3. REFRESH / OVERLAP / FLICKER HANDLING
                if (fullMatch !== suggestion) {
                    const position = getPositionFromIndex(texFile, m.index, fullMatch.length);
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        // Mark old versions for cleanup to avoid duplicate markers/flickering
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Skip if already anchored or rejected
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;
                    }

                    // Standard check to ignore commented-out code
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            suggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },

}